import { memo, useEffect, useState } from 'react';
import { EMFJS, RTFJS, WMFJS } from 'rtf.js';
import { RendererPropsData } from '../../types';
import { copyArrayBuffer } from '../../../../utils';

import { RtfContainer } from './rtf-renderer.styled';

RTFJS.loggingEnabled(false);
WMFJS.loggingEnabled(false);
EMFJS.loggingEnabled(false);

// RendererPropsData
export const RtfRenderer = memo(
  ({
    fileObj,
    thumbnail,
  }: {
    fileObj: RendererPropsData;
    thumbnail?: boolean;
  }) => {
    const [data, setData] = useState<any>(null);
    const [arrayBufferCopy, setArrayBufferCopy] = useState<ArrayBuffer | null>(
      null
    );
    const [doc, setDoc] = useState<any>(null);
    const [fileReader, setFileReader] = useState<FileReader | null>(null);

    useEffect(() => {
      setFileReader(new FileReader());
    }, []);

    useEffect(() => {
      if (fileReader && fileReader.readyState !== 1) {
        if ('arrayBuffer' in fileObj && !data && !arrayBufferCopy) {
          setArrayBufferCopy(copyArrayBuffer(fileObj.arrayBuffer));
        } else {
          fileReader.onload = (e) => {
            if (e.target?.result && typeof e.target.result !== 'string') {
              setDoc(new RTFJS.Document(e.target.result, {}));
            }
          };

          if (fileReader.readyState !== 2 && 'file' in fileObj) {
            fileReader.readAsArrayBuffer(fileObj.file);
          }
        }
      }
    }, [fileReader?.readyState]);

    useEffect(() => {
      if (arrayBufferCopy) {
        setDoc(new RTFJS.Document(arrayBufferCopy, {}));
      }
    }, [arrayBufferCopy]);

    useEffect(() => {
      if (doc) {
        doc
          .render()
          .then(function (htmlElements: HTMLElement[]) {
            setData(htmlElements);
          })
          .catch((error: Error) => {
            console.log(error);
          });
      }
    }, [doc]);

    return (
      <RtfContainer thumbnail={thumbnail}>
        {data &&
          data.map((el: any, index: number) => (
            <div
              key={index}
              dangerouslySetInnerHTML={{ __html: el.outerHTML }}
            />
          ))}
      </RtfContainer>
    );
  }
);
